import React, { useState } from "react";
import Modal from "../../../components/ui/Modal";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../helpers/constants";
import Auth from "../../../service/Auth";
import { toast } from "react-toastify";

const ManageUserChangePassword = ({ isOpen, onClose, userIdForPasswordUpdate, setUserIdForPasswordUpdate }) => {
  const authService = new Auth(API_URL);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [responseMsg, setReponseMsg] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const updatePasswordHandler = async () => {
    if (userIdForPasswordUpdate) {
      try {
        setLoading(true);
        const response = await authService.userUpdatePassword({ newPassword: newPassword, userId: userIdForPasswordUpdate });
        if (response.success) {
          toast.success("Password updated successfully");
          setNewPassword("");
          setUserIdForPasswordUpdate("");
          onClose(false);
        } else {
          setReponseMsg(response.message || "Failed to change password. Please try again.");
        }
      } catch (error) {
        console.error("Error during change password:", error);
        setReponseMsg(error.response?.data.message || "An error occurred during change password. Please try again.");
      } finally {
        setLoading(false);
      }
    } else {
      setReponseMsg("Please select the user first");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="w-full max-w-[30rem] overflow-y-auto "
      title={<h2 className="font-bold text-2xl">{t("Change User Password")}</h2>}
    >
      <div className="mb-4 px-5 py-5 mt-5">
        {responseMsg && <p className="text-red-500 sm:text-center text-md font-bold mb-4">{responseMsg}</p>}
        <label className="block ml-2 font-bold">{t("New password")}</label>
        <div className="telative space-x-4 mb-2">
          <input
            type="text"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="text-left w-full p-2 border border-slate-800 rounded text-black"
          />
          <div className="text-center">
            <button
              disabled={loading}
              onClick={updatePasswordHandler}
              className={` ${
                newPassword === "" ? "cursor-not-allowed opacity-50" : ""
              } mt-5 bg-primary hover:bg-primary/80 text-black w-full max-w-24 font-bold py-2 rounded-lg`}
            >
              {loading ? "Loading..." : "Update"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ManageUserChangePassword;
